import { Component, Prop, Vue } from 'vue-property-decorator';
import { logInTrackJS } from '@/errors/helpers';
@Component({
    name: 'StripePaymentElement',
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    value;
    @Prop({ required: true })
    elements;
    @Prop({ default: false })
    hideWalletPayments;
    mounted() {
        const el = this.elements.create('payment', this.options);
        el.on('loaderror', (e) => logInTrackJS(e.error.message, e.error));
        el.on('change', (event) => this.$emit('input', event.value.type));
        el.on('focus', (e) => this.$emit('focus', e));
        el.mount(this.stripeElement);
    }
    get options() {
        return {
            paymentMethodOrder: ['apple_pay', 'google_pay', 'card'],
            layout: 'accordion',
            fields: {
                billingDetails: {
                    address: 'never',
                    name: 'never',
                    email: 'never',
                },
            },
            wallets: {
                applePay: this.walletsEnabled,
                googlePay: this.walletsEnabled,
            },
        };
    }
    get walletsEnabled() {
        return this.hideWalletPayments ? 'never' : 'auto';
    }
    get stripeElement() {
        return this.$refs.stripeElement;
    }
}
